import * as React from 'react';
import { Image, Linking, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Colors, Fonts } from '../utils/Constants';
import CheckBoxItem from '../components/CheckBoxItem';

export default class CallAction extends React.PureComponent{
  constructor(props){
    super(props);
    this.state= {
        hovering: false,
        clicked: false,
        expanded: false
    }
  }

  clickedButton = () => {
    let collapsedScreen = this.props.screenWidth < 650;
    if (collapsedScreen) {
      this.setState({
        expanded: !this.state.expanded
      });
    } else {
      if (!!!this.props.number) return;
      this.setState({
        clicked: true
      });
      this.props.checkOffAction();
      window.open('tel:' + this.props.number, "_self")
    }
  }

  hoverButton = () => {
    if(this.state.clicked == false && this.props.screenWidth >= 650){
      this.setState({
        hovering: !this.state.hovering
      })
    }
  }
  generateTwitterLink = (twitter_profile) => {
    this.props.checkOffAction();
    let shareLink = `${window.location.href}`;
    let base = `https://twitter.com/intent/tweet?`;
    let textToShare = this.props.script.replace("@person", "@" + twitter_profile);
    let link = `${base}text=${textToShare}`;
    return link;
  }

  openTwitterLink = (twitter_profile) => {
    Linking.openURL(this.generateTwitterLink(twitter_profile));
  }

  render(){
    let colors = {
      defaultBgColor: this.props.defaultBgColor ? this.props.defaultBgColor : 'white',
      highlightedBgColor: this.props.highlightedBgColor ? this.props.highlightedBgColor : 'black',
      defaultTextColor: this.props.defaultTextColor ? this.props.defaultTextColor : '#4A4A4A',
      highlightedTextColor: this.props.highlightedTextColor ? this.props.highlightedTextColor : 'white'
    }

    var properties = {
      phone: require('../assets/images/unhoverphone.svg'),
      twitter: require('../assets/images/twitterunhover.svg'),
      email: require('../assets/images/emailunhover.svg'),
      color: colors.defaultBgColor,
      textColor: colors.defaultTextColor
    };

    if(this.state.clicked || this.props.actionCompleted){
      properties = {
        color: colors.highlightedBgColor,
        textColor: colors.highlightedTextColor,
        phone: require('../assets/images/hoverphone.svg'),
        twitter: require('../assets/images/twitterhover.svg'),
        email: require('../assets/images/emailhover.svg')
      }
    }
    else{
      if (this.state.hovering) {
        properties = {
            color: colors.highlightedBgColor,
            textColor: colors.highlightedTextColor,
            phone: require('../assets/images/hoverphone.svg'),
            twitter: require('../assets/images/twitterhover.svg'),
            email: require('../assets/images/emailhover.svg')
        }
      }
      else {
          properties = {
            color: colors.defaultBgColor,
            textColor: colors.defaultTextColor,
            phone: require('../assets/images/unhoverphone.svg'),
            twitter: require('../assets/images/twitterunhover.svg'),
            email: require('../assets/images/emailunhover.svg')
          }
      }
    }
    let collapsedScreen = this.props.screenWidth < 650;

    return (
    <View>
    <TouchableOpacity style={{width: this.props.width, height: this.props.height, marginBottom: 16}} onPress={() => this.clickedButton()} onMouseEnter={() => this.hoverButton()} onMouseLeave={() => this.hoverButton()}>
      <View style = {[styles.button, {width: '100%', height: '100%', backgroundColor: properties.color}]}>
        <View style={{flex: 4, paddingRight: 20}}>
            <Text style={[styles.contactname, {color: properties.textColor}]}>{this.props.title}</Text>
            <Text style={[styles.description, {color: properties.textColor}]}>{this.props.text}</Text>
        </View>
        {!collapsedScreen &&
        <View style={{flexDirection: 'row', alignItems: 'center', flex: 4, paddingLeft: 10}}>
          <Image
              style={{width: 40, height: 40, resizeMode: 'contain', marginRight: 10}}
              source={properties.phone}
          />
          <Text style={[styles.contactname, {color: properties.textColor}]}>{!!this.props.number ? this.props.number : "..."}</Text>
        </View>
        }
        <View style={{flex: 1.5, flexDirection: 'row', alignItems: 'center'}}>
          {collapsedScreen &&
            <Image
              style={{marginLeft: 30, paddingRight: 20, tintColor: properties.textColor, width: 35, height: 35, resizeMode: 'contain', transform: [{ rotate: this.state.expanded ? '180deg':'0deg'}]}}
              source={properties.textColor === 'white' ? require('../assets/images/dropdownarrow_white.svg') : require('../assets/images/dropdownarrow_black.svg')}
            />
          }
          {(!!this.props.twitter && !collapsedScreen) &&
          <TouchableOpacity onPress={() => this.openTwitterLink(this.props.twitter)}>
            <Image
              style={{width: 40, height: 40, resizeMode: 'contain', justifyContent: 'flex-end', flex: 1}}
              source={properties.twitter}
            />
          </TouchableOpacity>
          }
          {(!!this.props.email && !collapsedScreen) &&
          <TouchableOpacity style={{paddingRight: 20, paddingLeft: 10}} onPress={() => Linking.openURL(this.props.email)}>
            <Image
              style={{width: 40, height: 40, resizeMode: 'contain', justifyContent: 'flex-end', flex: 1}}
              source={properties.email}
            />
          </TouchableOpacity>
          }
        </View>
      </View>
    </TouchableOpacity>
    {(collapsedScreen && this.state.expanded) &&
      <View style={{width: '100%', alignItems: 'center'}}>
        {!!this.props.number && <CheckBoxItem
          key={'phone'}
          item={{name: 'Make a Phone Call', description: 'Use the script to talk :)', link: 'tel:' + this.props.number}}
          width = {'90%'}
          defaultBgColor={'white'}
          height = {this.props.height}
          borderWidth = {1}
          actionCompleted = {false}
          checkOffAction = {this.props.checkOffAction}
        />}
        {!!this.props.email && <CheckBoxItem
          key={'email'}
          item={{name: 'Send an Email', link: this.props.email}}
          width = {'90%'}
          defaultBgColor={'white'}
          height = {this.props.height}
          borderWidth = {1}
          actionCompleted = {false}
          checkOffAction = {this.props.checkOffAction}
        />}
        {!!this.props.twitter && <CheckBoxItem
          key={'twitter'}
          item={{name: 'Send a Tweet', link: this.generateTwitterLink(this.props.twitter)}}
          width = {'90%'}
          defaultBgColor={'white'}
          height = {this.props.height}
          borderWidth = {1}
          actionCompleted = {false}
          checkOffAction = {this.props.checkOffAction}
        />}
      </View>
    }
    </View>
    );
  }
}

const styles = StyleSheet.create({
  button: {
    padding: 27,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
    borderColor: 'black',
    borderWidth: 1,
  },
  contactname: {
    fontFamily: Fonts.mainFont,
    fontSize: 18.65,
    fontWeight: 'bold'
  },
  description: {
    fontFamily: Fonts.mainFont,
    fontSize: 13,
    fontWeight: 'normal'
  }
});